module.exports = __webpack_public_path__ + "img/babo-2.50b5e870.png";